import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Selector from '../../components/forms/Selector';
import language from '../../variables/language';
import * as api from './api';
import '../../css/modals.css';

// Kept intentionally minimal - description/classification/type are all
// still editable right after creation via BuilderHeader.jsx, no need to
// front-load every field into the create step.
const TEXT_FIELDS = [
   {name:'name', type:'text'},
];
const SELECT_FIELDS = [
   {name:'level', url:'/api/levels'},
];

const emptyValues = () => ({name:'', level:''});

export default function ExerciseTemplateCreateModal({ isOpen, onClose, onCreated }) {
   const navigate = useNavigate();
   const [values, setValues] = useState(emptyValues());
   const [saving, setSaving] = useState(false);

   if(!isOpen) return '';

   const stopProp = e => e.stopPropagation();

   const handleFieldChange = (name, value) => {
      setValues(prev => ({...prev, [name]: value}));
   }

   const handleClose = () => {
      setValues(emptyValues());
      onClose();
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if(saving || !values.name.trim()) return;
      setSaving(true);
      const payload = {};
      Object.keys(values).forEach(key => {
         if(values[key] !== '') {
            payload[key] = values[key];
         }
      });
      api.createExerciseTemplate(payload).then((response) => {
         setValues(emptyValues());
         onCreated(response.data);
      }).catch(err => {
         if(err.response && err.response.status === 401){
            navigate('/login');
         }
         console.log(err);
      }).finally(() => {
         setSaving(false);
      });
   }

   return (
      <div className="modal-update" onClick={handleClose} style={{ display: 'flex' }}>
         <div className="modal-window" onClick={stopProp}>
            <h3 className="modal-w-title">Новий шаблон вправи</h3>
            <form onSubmit={handleSubmit}>
               <div className='exercise-template-fields-grid'>
                  {TEXT_FIELDS.map(f => (
                     <div className='flex-from-input-wraper exercise-template-field' data-label={language[language.lang][f.name]} key={f.name}>
                        <input className='submit-field from-input txt-c' type={f.type}
                           placeholder={language[language.lang][f.name]}
                           value={values[f.name]}
                           onChange={(e) => handleFieldChange(f.name, e.target.value)} />
                     </div>
                  ))}
                  {SELECT_FIELDS.map(f => (
                     <div className='flex-from-input-wraper exercise-template-field' data-label={language[language.lang][f.name]} key={f.name}>
                        <Selector className='submit-field form-selection txt-c'
                           name={f.name} url={f.url} value={values[f.name]} disabled={false}
                           selectorsHundler={(value) => handleFieldChange(f.name, value)} />
                     </div>
                  ))}
               </div>
               <button type='submit' className='form-button txt-c' disabled={saving || !values.name.trim()} style={{marginTop:14}}>
                  {saving ? language[language.lang]['Loading ...'] : language[language.lang].save}
               </button>
            </form>
         </div>
      </div>
   );
}
